<template>
  <section>
    <h2 class="h2Title">게시판 등록</h2>
    <div class="formInfo">
      <v-form ref="formBoard">
      <dl class="infoCont">
        <dt class="formInfoTxt">게시판명 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-text-field v-model="board.boardName" :rules="[rules.required]" label="" dense solo outlined flat clearable/>
          </v-col>
        </dd>
      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt">게시판 유형 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-col class="mgr" sm="6">
              <div class="d-flex">
                <ul v-for="(t) in boardTypeItems" :key="t.value">
                  <v-checkbox v-model="board.boardType" :value="t.value" :label="t.text" hide-details
                              color="primary" :rules="[rules.required]"></v-checkbox>
                </ul>
              </div>
            </v-col>
            <!--            <v-select :items="typeItems" item-value="value" item-text="text" v-model="board.boardType"-->
            <!--                      dense clearable solo outlined flat required label="게시판 유형"/>-->
          </v-col>
        </dd>
      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt">게시판 내용</dt>
        <dd class="formInfoArea">
          <v-col class="mgr">
<!--            <v-textarea-->
<!--                name="input-7-1"-->
<!--                label="내용을 작성해주세요"-->
<!--                value=""-->
<!--                hint="Hint text"-->
<!--                solo-->
<!--                flat-->
<!--                outlined-->
<!--                v-model="board.boardContents"-->
<!--            />-->

            <editor-component
                ref="boardContents"
                :val="board.boardContents"
                :uploaded="fileMeta"
                @callback-upload="uploadImage"
                label="게시판 내용" />
          </v-col>
        </dd>
      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt"> 파일 첨부</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.hasAttachment"
                flat
                color="primary"
                :label="board.hasAttachment ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>

        <dt class="formInfoTxt"> 공지 사항</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.hasNotice"
                flat
                color="primary"
                :label="board.hasNotice ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>
      </dl>

      <dl class="infoCont">
        <dt class="formInfoTxt"> 댓글</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.hasComment"
                flat
                color="primary"
                :label="board.hasComment ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>

        <dt class="formInfoTxt"> 공지 게시기간 설정</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.hasPeriod"
                flat
                color="primary"
                :label="board.hasPeriod ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>
      </dl>

      <dl class="infoCont">
        <dt class="formInfoTxt"> 페이지 게시물 수</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="1">
            <v-text-field v-model="board.pageSize" label="" dense solo outlined flat clearable maxlength="3"/>
          </v-col>
        </dd>

        <dt class="formInfoTxt"> 새글 표시 기간</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="1">
            <v-text-field v-model="board.newPeriod" label="" dense solo outlined flat clearable maxlength="2"/>
          </v-col>
        </dd>
      </dl>

      <dl class="infoCont">
        <dt class="formInfoTxt">사용 그룹 분류 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <div class="d-flex">
              <ul v-for="(t) in targetTypeItems" :key="t.value">
                <v-checkbox v-model="board.targetType" :value="t.value" :label="t.text" hide-details
                            :color="t.color" :rules="[rules.required]" @change="board.group ? board.group.groupId = null : board.group = {groupId:null}"></v-checkbox>
              </ul>
            </div>
          </v-col>
        </dd>

        <dt class="formInfoTxt" v-if="['TARGET_DEPARTMENT','TARGET_CLUB'].includes(board.targetType)">
          <template v-for="(t, index) in targetTypeItems">
            <span v-if="t.value === board.targetType" :key="index"> {{t.text}} </span>
          </template>
        </dt>
        <dd class="formInfoArea" v-if="['TARGET_DEPARTMENT','TARGET_CLUB'].includes(board.targetType)">
          <v-col class="mgr" sm="6">
            <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="board.group.groupId"
                      dense clearable outlined flat required label="선택" :rules="[rules.required]" v-if="board.targetType === 'TARGET_CLUB'"/>

            <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="board.group.groupId"
                      dense clearable outlined flat required label="선택" :rules="[rules.required]" v-else/>

          </v-col>
        </dd>
      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt"> 게시판 사용 여부</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.activated"
                flat
                color="primary"
                :label="board.activated ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>
        <dt class="formInfoTxt"> 새글 대표 연락처로 알림</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            <v-switch
                v-model="board.notifiedEmail"
                flat
                color="primary"
                :label="board.notifiedEmail ? '사용' : '사용안함'"
            ></v-switch>
          </v-col>
        </dd>
      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt">권한 설정 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr">
<!--            <div v-for="(i, idx) in permissionFunctionItems" :key="i.value">-->
<!--                {{idx}}-->

                <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="permissions.READ"
                          dense clearable flat label="조회 권한" :rules="[rules.required, rules.qtZero]" multiple/>
                <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="permissions.WRITE"
                          dense clearable flat label="생성 권한" :rules="[rules.required, rules.qtZero]" multiple/>
                <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="permissions.COMMENT"
                          dense clearable flat label="댓글 권한" :rules="[rules.required, rules.qtZero]" multiple/>
                <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="permissions.NOTICE"
                          dense clearable flat label="공지 권한" :rules="[rules.required, rules.qtZero]" multiple/>
                <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="permissions.ADMIN"
                          dense clearable flat label="관리자 권한" :rules="[rules.required, rules.qtZero]" multiple/>

<!--            </div>-->
          </v-col>
        </dd>
        <dt class="formInfoTxt">카테고리 설정</dt>
        <dd class="formInfoArea">

          <v-col class="mgr">
            <v-data-table
                id="categoryTable"
                item-key="categoryId"
                :hide-default-footer="true"
                disable-pagination
                :headers="categoryHeader"
                :items="categories"
                class="elevation-1"
            >
              <template v-slot:body="props">
                <draggable
                    :list="categories"
                    @change="log"
                    tag="tbody"
                >
                  <tr
                      v-for="(item, index) in props.items"
                      :key="index"
                  >
                    <td>
                      <v-icon
                          small
                          class="page__grab-icon"
                      >
                        mdi-arrow-all
                      </v-icon>
                    </td>
<!--                    <td> {{ index + 1 }} </td>-->
                    <td> {{ item.categoryName }} </td>
                    <td> {{ item.createdAt ? $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : "" }} </td>
                    <td> {{ item.activated ? '사용' : '사용안함' }} </td>
                    <td>
                      <v-icon
                          small
                          @click="updateCategoryForm(item)"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                          small
                          @click.stop="deleteCategory(index)"
                      >
                        mdi-delete
                      </v-icon>
                    </td>
                  </tr>

                </draggable>
              </template>
            </v-data-table>
            <div class="btnStyleBx">
              <div class="btnCommon justify-center">

                <v-btn class="vBtn" @click="createCategoryForm" color="success" dark>
                  <v-icon left>mdi mdi-playlist-plus</v-icon> 카테고리 추가
                </v-btn>
                <v-btn class="vBtn" @click="resetCategory">
                  <v-icon left>mdi mdi-reload</v-icon> 리셋
                </v-btn>

              </div>
            </div>

<!--            {{ categories}}-->
          </v-col>
        </dd>
      </dl>
      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save()">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList()">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
      </div>
    </div>


    <category-form
        :visible="formVisible"
        :item="category"
        @callback-canceled="formVisible = false"
        @callback-saved="savedCategory"
    />
  </section>
</template>

<script>
import roleApi from '@/api/RoleApi'
import boardApi from '@/api/BoardApi'
import groupApi from "@/api/GroupApi";

import EditorComponent from "../component/EditorComponent";

import CategoryForm from "./CategoryForm";
import draggable from "vuedraggable";
import _ from 'lodash';

export default {
  name: "BoardForm",
  components: {
    'editor-component': EditorComponent,
    draggable,
    'category-form': CategoryForm
  },
  props: {
    id: String
  },
  data: () => ({
    menu: false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      qtZero: value => value !== null && value.length !== 0 || '필수 입력 항목입니다.'
    },
    board: {
      imageFileId: null,
      mediaName: null,

      boardName: null,
      content: null,
      boardType:'TYPE_GENERAL',
      targetType:'TARGET_GENERAL',
      activated:true,
      hasAttachment: true,
      pageSize:10,
      newPeriod:3,
      group:{
        groupId:null
      }
    },
    permissions:{
      READ: [],
      WRITE: [],
      COMMENT: [],
      NOTICE: [],
      ADMIN: [],
    },
    permission: {},
    roles:[],
    boardTypeItems: [
        {
          'value': 'TYPE_GENERAL',
          'text': '일반게시판'
        },
        {
          'value': 'TYPE_PHOTO',
          'text': '사진게시판'
        },
        {
          'value': 'TYPE_SCHEDULE',
          'text': '일정게시판'
        }
    ],
    targetTypeItems: [{
      'value': 'TARGET_DEPARTMENT',
      'text': '분과',
      'color': 'primary'
    },
    {
      'value': 'TARGET_CLUB',
      'text': '동호회',
      'color': 'green'
    }, {
      'value': 'TARGET_GENERAL',
      'text': '홈페이지',
      'color': 'gray'
    }],
    departmentItems:[],
    clubItems:[],
    imageFileUrl: null,
    endPoint:process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    fileMeta:{},
    categoryHeader: [
      {text: '순서', align: 'left', sortable: false},
      {text: '카테고리 명', value: 'categoryName', align: 'left', sortable: false},
      {text: '생성일', value: 'createdAt', sortable: false},
      {text: '사용여부', value: 'activated', sortable: false},
      {text: '관리', value: 'actions', sortable: false}
    ],
    categories: [],
    category:null,
    formVisible: false
  }),
  methods: {
    uploadImage(f) {
      boardApi.uploadImage(f).then(res => {
        // console.log(res);
        this.fileMeta = res;
      });
    },
    goList() {
      this.$router.push({path: '/board'})
    },
    async onSelectImage(file) {
      let url = await this.readImage(file);
      // let attachmentId = await attachmentApi.upload(file);

      this.imageFileUrl = url;
      // this.board.imageFileId = attachmentId;
    },
    /*파일읽기 */
    readImage(file) {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      return new Promise(resolve => {
        fileReader.onload = e => {
          resolve(e.target.result);
        }
      });
    },
    async save() {

      if(!await this.$refs.formBoard.validate())
        return;

      // this.board.boardPermissions.push(this.permission_r.map(p => {return {functionType:'r', roleId:p}}))

      this.board.boardPermissions = Object.entries(this.permissions).flatMap(([k, v]) => {
        // console.log(k)
        // console.log(v)
        return v?.map(p => {return {functionType:k, roleId:p}})??[]
      });

      this.board.boardContents = this.$refs.boardContents.getValue();

      this.board.boardCategories = _.cloneDeep(this.categories).reverse().map((c, i) => {
        c.orderNo = i;
        return c;
      });

      boardApi.save(this.board).then(data => {
        if (data) {
          if(this.board.boardId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      });
    },
    log: function(e) {
      // window.console.log("Future index: " + e.draggedContext.futureIndex);
      window.console.log(e);
    },
    createCategoryForm() {
      this.formVisible = true;
      this.category = {};
    },
    resetCategory() {
      this.categories = _.cloneDeep(this.board?.boardCategories??[]);
      this.categories.sort((a, b) => {
        return a.orderNo > b.orderNo ? -1 : a.orderNo < b.orderNo ? 1 : 0;
      })
    },
    updateCategoryForm(item) {
      this.formVisible = true;
      this.category = item;
    },
    savedCategory(item) {
      this.formVisible = false;
      if(item.categoryId) {

        this.categories = this.categories.map(c => {
          if(c.categoryId === item.categoryId) {
            // item.orderNo = i;
            return item;
          } else {
            // c.orderNo = i;
            return c;
          }
        });
      } else {
        this.categories.push(item);
      }

    },
    deleteCategory(index) {
      this.categories = this.categories.filter((c,i) => i !== index);
    }
  },
  created() {
    roleApi.list(true).then(data => {
      this.roles = data;
    });
    if(this.id) {
      boardApi.get(this.id).then(data => {
        console.log(data);
        this.board = data;
        this.board.boardPermissions.forEach(p => {
          this.permissions[p.id.functionType].push(p.id.roleId);
        });

        this.categories = _.cloneDeep(this.board.boardCategories);
        this.categories.sort((a, b) => {
          return a.orderNo > b.orderNo ? -1 : a.orderNo < b.orderNo ? 1 : 0;
        })
      });
    }

    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}
</style>